<template>
<div class="chapter">
<div class="inner_page">
<p class="fm" id="page_12">P<span class="small">ART </span> I</p>
<p class="fm1">God’s Essential Being and Eternal Plan</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0005.vue?cbfef784